import { TextField, type TextFieldProps } from '@mui/material';
import type { UseChatResult } from './use-chat';

export interface ChatTextFieldProps extends Omit<TextFieldProps, 'onChange'> {
  onChange: UseChatResult['handleInputChange'];
  onSubmit: () => void;
}

function ChatTextField({
  onChange,
  onSubmit,
  sx,
  ...props
}: ChatTextFieldProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onSubmit();
    }
  };

  return (
    <TextField
      {...props}
      variant='standard'
      className='w-full border-0 my-2'
      onChange={onChange}
      onKeyDown={handleKeyDown}
      border='none'
      fullWidth
      multiline
      slotProps={{
        input: {
          disableUnderline: true,
        },
      }}
      minRows={1}
      placeholder='Ask me anything...'
    />
  );
}

export default ChatTextField;
